import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { ApiError } from "components";
import { UploadAvatar } from "./component/UploadAvatar";
import { createAvaterImage } from "../store/action";

interface CreateImageProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
export interface avatarImageError {
  image?: string; 
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CreateImageProps & avatarImageError ;

const CreateAvatar: React.FC<Props> = ({ closeModal, onCreateAvatar }) => {
  const [formData, setFormData] = useState({
    image: "",

  });
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<avatarImageError>({});
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const imageAvatarState = useSelector(
    (state: any) => state.avatarImageReducer.avatarImageState
  );
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    if (!imageFile) {
    setError({ image: "Please select an image to upload." });
    return;
  }
    let uploadedFilename: string | undefined = undefined;
    if (imageFile) {
      const uploadUrl = `${process.env.REACT_APP_AVATAR_UPLOAD_BASE_URL}`;
      const form = new FormData();
      form.append("file", imageFile);
      const response = await fetch(uploadUrl ?? "", {
        method: "POST",
        body: form,
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Failed to upload image");
      }
      const result = await response.json();
      uploadedFilename = result?.avatarImageUrl;

      if (!uploadedFilename) {
        console.error("Image upload response invalid", result);
        throw new Error("Image upload response invalid");
      }
    }
      if (uploadedFilename) {
        formData.image = uploadedFilename;
      }
      setLoading(true);
      onCreateAvatar(formData.image);
      setSubmitted(true);
      setLoading(false);
  };
  useEffect(() => {
    if (!imageAvatarState.isLoading && submitted) {
      if (imageAvatarState.error) {
        setApiError(imageAvatarState.error); 
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [imageAvatarState.isLoading, imageAvatarState.error, submitted, closeModal]);
  return (
    <>
      <UploadAvatar
        header="Upload Avatar Image"
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSave}
        loading={loading}
        handleImageFileChange={setImageFile}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateAvatar: (avatar_image_url: string) => dispatch(createAvaterImage(avatar_image_url)),
});

export default connect(null, mapDispatchToProps)(CreateAvatar);
